import { MinionName } from './minion-name';
import type { MinionOutput, PluginExtraInfo } from './types';

/**
 * Extracts search results from minion outputs.
 * Finds the search minion and parses its minion_extra_info to get searchResults.
 *
 * The search minion's data structure is:
 * minion_extra_info → JSON → functionMessage.pluginInvocationInfo.extraInfo → JSON → PluginExtraInfo
 */
export const getSearchResultsFromMinions = (
	minionOutputs: MinionOutput[] | undefined,
): PluginExtraInfo | null => {
	if (!Array.isArray(minionOutputs)) {
		return null;
	}

	// Find search minion - check if minion_id contains 'search' (case insensitive)
	const searchMinion = minionOutputs.find((minion) => {
		const minionInfo = Array.isArray(minion) ? minion[0] : minion;
		return minionInfo.minion_id?.toLowerCase().includes(MinionName.SEARCH);
	});

	if (!searchMinion) {
		return null;
	}

	const minionInfo = Array.isArray(searchMinion) ? searchMinion[0] : searchMinion;

	if (!minionInfo.minion_extra_info) {
		return null;
	}

	try {
		const parsedExtraInfo = JSON.parse(minionInfo.minion_extra_info);

		// Extract from functionMessage.pluginInvocationInfo.extraInfo
		if (parsedExtraInfo.functionMessage?.pluginInvocationInfo?.extraInfo) {
			try {
				return JSON.parse(
					parsedExtraInfo.functionMessage.pluginInvocationInfo.extraInfo,
				) as PluginExtraInfo;
			} catch {
				return null;
			}
		}

		return null;
	} catch {
		return null;
	}
};
